"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = _interopRequireDefault(require("./styles"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MenuLinks = function MenuLinks(_ref) {
  var classes = _ref.classes,
      links = _ref.links,
      clsName = _ref.clsName,
      hamHandler = _ref.hamHandler;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, links.length >= 1 && links.map(function (_ref2) {
    var name = _ref2.name,
        _ref2$to = _ref2.to,
        to = _ref2$to === void 0 ? "/" : _ref2$to,
        _ref2$exact = _ref2.exact,
        exact = _ref2$exact === void 0 ? false : _ref2$exact,
        badgeContent = _ref2.badgeContent;
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      key: name,
      to: to,
      exact: exact,
      className: clsName ? classes.pageLinkContainerMobile : classes.pageLinkContainer,
      onClick: hamHandler ? hamHandler : function () {}
    }, badgeContent ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "subtitle1",
      className: classes.pageLink
    }, name, /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
      color: "secondary",
      classes: {
        badge: classes.listingsBadge
      },
      badgeContent: badgeContent
    }, /*#__PURE__*/_react["default"].createElement("span", null))) : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "subtitle1",
      className: classes.pageLink
    }, name));
  }));
};

MenuLinks.propTypes = {
  classes: _propTypes["default"].object,
  links: _propTypes["default"].array,
  clsName: _propTypes["default"].string,
  hamHandler: _propTypes["default"].func
};
MenuLinks.defaultProps = {
  links: []
};

var _default = (0, _withStyles["default"])(_styles["default"])(MenuLinks);

exports["default"] = _default;